if (!customElements.get('localization-form')) customElements.define('localization-form', class extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('form');
    if (!form) return;

    const countryInput = form.querySelector('input[name="country_code"]');
    const countrySelect = form.querySelector('select[name="country_code"]');
    if (countrySelect) countrySelect.addEventListener('change', () => form.requestSubmit());

    const items = [...this.querySelectorAll('.country-options li')];
    const visibleItems = () => items.filter((item) => !item.hidden);
    const select = (item) => {
      if (!countryInput) return;
      items.forEach((option) => {
        const selected = option === item;
        option.classList.toggle('active', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      countryInput.value = item.dataset.value;
    };
    const focusItem = (item) => {
      if (!item) return;
      items.forEach((option) => { option.tabIndex = option === item ? 0 : -1; });
      item.focus();
    };

    items.forEach((item) => {
      item.addEventListener('click', () => select(item));
      item.addEventListener('keydown', (event) => {
        const list = visibleItems();
        const index = list.indexOf(item);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          focusItem(list[index + (event.key === 'ArrowDown' ? 1 : -1)]);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          focusItem(event.key === 'Home' ? list[0] : list[list.length - 1]);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          item.click();
        }
      });
    });

    const filter = this.querySelector('[data-country-filter]');
    const empty = this.querySelector('[data-country-filter-empty]');
    if (!filter) return;

    const partial = (query, text) => {
      let from = 0;
      for (const char of query) {
        const at = text.indexOf(char, from);
        if (at < 0 || (from && at - from > 1)) return false;
        from = at + 1;
      }
      return true;
    };

    filter.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        focusItem(visibleItems()[0]);
      }
    });
    filter.addEventListener('input', () => {
      const query = filter.value.trim().toLowerCase();
      let visible = 0;
      items.forEach((item) => {
        const name = (item.querySelector('span')?.textContent.split(' (')[0] || '').toLowerCase();
        const code = item.dataset.value.toLowerCase();
        const matches = query === '' || partial(query, name) || partial(query, code);
        item.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
      const current = items.find((item) => item.tabIndex === 0);
      if (!current || current.hidden) {
        items.forEach((item) => { item.tabIndex = -1; });
        const first = items.find((item) => !item.hidden);
        if (first) first.tabIndex = 0;
      }
    });

    const list = this.querySelector('.country-options');
    const centerSelected = () => {
      const selected = list?.querySelector('li.active');
      if (!list || !selected || !list.clientHeight) return;
      const top = selected.getBoundingClientRect().top - list.getBoundingClientRect().top;
      list.scrollTop += top - (list.clientHeight - selected.offsetHeight) / 2;
    };
    const modal = this.closest('dialog-component');
    if (!modal) return;
    const onOpen = () => {
      if (filter.value) {
        filter.value = '';
        filter.dispatchEvent(new Event('input'));
      }
      requestAnimationFrame(centerSelected);
    };
    if (modal.classList.contains('active')) onOpen();
    new MutationObserver(() => {
      if (modal.classList.contains('active')) onOpen();
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }
});
